export default __webpack_public_path__ + "static/media/aga.7a5e6597.png";